export const messages = {
  en: {
    equipmentAccount: {
      addEquipment: 'Add Equipment',
      batchPrint: 'Batch Print',
      searchCondition: 'Search Condition',
      hide: 'Hide',
      more: 'More',
      machineName: 'Equipment Name',
      machineNamePlaceholder: 'Please enter equipment name',
      machineCode: 'Equipment Code',
      machineCodePlaceholder: 'Please enter equipment code',
      state: 'Status',
      selectState: 'Please select status',
      importanceLevel: 'Importance Level',
      selectImportanceLevel: 'Please select importance level',
      newLocation: 'New Location',
      selectLocation: 'Please select location',
      selectLocationFirst: 'Please select location first',
      moveEquipment: 'Move Equipment',
      confirmOperation: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this equipment?',
      viewEquipment: 'View Equipment',
      printLabel: 'Print Label',
      printQty: 'Print Quantity',
      printPreview: 'Print Preview',
      importEquipment: 'Import Equipment',
      selectFile: 'Select File',
      fileTip: 'Only .xls, .xlsx files can be uploaded, and no more than 2MB',
      downloadTemplate: 'Download Template',
      downloadTip1: 'Please download',
      downloadTip2: 'to prepare data before uploading',
      selectFileFirst: 'Please select file first',
      invalidFileType: 'Invalid file type, only .xls, .xlsx files are allowed',
      fileSizeExceed: 'File size cannot exceed 2MB',
      selectTypeFirst: 'Please select equipment type first',
      importSuccess: 'Import successfully',
      stateDescription: 'Equipment status: in use, out of service, etc.',
      brand: 'Brand',
      model: 'Model',
      locationDetail: 'Location Detail',
      firstEnableTime: 'First Enable Time',
      warrantyDeadline: 'Warranty Deadline',
      usefulLife: 'Useful Life',
      purchasePrice: 'Purchase Price',
      netWorth: 'Net Worth',
      useOrgName: 'Use Department',
      useUserName: 'User',
      chargeOrgName: 'Responsible Department',
      chargeUseName: 'Responsible Person',
      remark: 'Remark'
    }
  },
  zh: {
    equipmentAccount: {
      addEquipment: '添加设备',
      batchPrint: '批量打印',
      searchCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      machineName: '设备名称',
      machineNamePlaceholder: '请输入设备名称',
      machineCode: '设备编码',
      machineCodePlaceholder: '请输入设备编码',
      state: '状态',
      selectState: '请选择状态',
      importanceLevel: '重要等级',
      selectImportanceLevel: '请选择重要等级',
      newLocation: '新位置',
      selectLocation: '请选择位置',
      selectLocationFirst: '请先选择位置',
      moveEquipment: '移动设备',
      confirmOperation: '确认操作',
      confirmDelete: '确定删除该设备吗？',
      viewEquipment: '查看设备',
      printLabel: '打印标签',
      printQty: '打印数量',
      printPreview: '打印预览',
      importEquipment: '导入设备',
      selectFile: '选择文件',
      fileTip: '只能上传.xls, .xlsx文件，且不超过2MB',
      downloadTemplate: '下载模板',
      downloadTip1: '请先下载',
      downloadTip2: '准备数据后上传导入',
      selectFileFirst: '请先选择文件',
      invalidFileType: '文件类型不正确，只能上传.xls, .xlsx文件',
      fileSizeExceed: '文件大小不能超过2MB',
      selectTypeFirst: '请先选择设备分类',
      importSuccess: '导入成功',
      stateDescription: '设备状态分为：使用中、停用中等状态',
      brand: '品牌',
      model: '型号',
      locationDetail: '位置详情',
      firstEnableTime: '首次启用时间',
      warrantyDeadline: '保修截止日期',
      usefulLife: '使用年限',
      purchasePrice: '采购价格',
      netWorth: '资产净值',
      useOrgName: '使用部门',
      useUserName: '使用人',
      chargeOrgName: '责任部门',
      chargeUseName: '责任人',
      remark: '备注'
    }
  }
}